export const WEFAT_PAGE_DOM_API_NAMES = Object.freeze(['createSelectorQuery', 'nextTick']);
export class WxPageDomRuntimeError extends Error {
    code;
    errCode;
    remediation;
    constructor(code, message, remediation, cause) {
        super(`${code} ${message}`);
        this.name = 'WxPageDomRuntimeError';
        this.code = code;
        this.errCode = code;
        this.remediation = remediation;
        if (cause !== undefined)
            Object.defineProperty(this, 'cause', { value: cause });
    }
}
function driverError(api, error) {
    if (error instanceof WxPageDomRuntimeError)
        return error;
    return new WxPageDomRuntimeError('WF6220', `wx.${api} failed: ${error instanceof Error ? error.message : String(error)}`, 'Call the page DOM API after the generated application has mounted an active page.', error);
}
export function createPageDomWxApis(options) {
    if (options === null || typeof options !== 'object' || options.driver === null || typeof options.driver !== 'object') {
        throw new TypeError('createPageDomWxApis requires a page DOM driver');
    }
    if (typeof options.driver.createSelectorQuery !== 'function' || typeof options.driver.nextTick !== 'function') {
        throw new TypeError('page DOM driver requires createSelectorQuery and nextTick');
    }
    if (options.onCallbackError !== undefined && typeof options.onCallbackError !== 'function') {
        throw new TypeError('onCallbackError must be a function when provided');
    }
    return Object.freeze({
        createSelectorQuery(...args) {
            if (args.length > 0) {
                throw new WxPageDomRuntimeError('WF6221', 'wx.createSelectorQuery does not accept arguments', 'Call wx.createSelectorQuery() without arguments and build the query through its chain methods.');
            }
            try {
                const query = options.driver.createSelectorQuery();
                if (query === null || typeof query !== 'object')
                    throw new TypeError('driver returned no query');
                return query;
            }
            catch (error) {
                throw driverError('createSelectorQuery', error);
            }
        },
        nextTick(callback) {
            if (typeof callback !== 'function') {
                throw new WxPageDomRuntimeError('WF6221', 'wx.nextTick callback must be a function', 'Pass one callback that can run after the active Vue render flush.');
            }
            try {
                void Promise.resolve(options.driver.nextTick(() => {
                    try {
                        callback();
                    }
                    catch (error) {
                        if (options.onCallbackError !== undefined)
                            options.onCallbackError(error, 'nextTick');
                        else
                            queueMicrotask(() => { throw error; });
                    }
                })).catch((error) => {
                    queueMicrotask(() => { throw driverError('nextTick', error); });
                });
            }
            catch (error) {
                throw driverError('nextTick', error);
            }
        },
    });
}
//# sourceMappingURL=page-dom-adapter.js.map